{
  "de": {
    "activities": {
      "labels": {
        "noProject": "Ohne Projekt"
      }
    },
    "aiGenerated": {
      "label": "KI-generiert",
      "tooltip": "Dieses Bild wurde mit Künstlicher Intelligenz erstellt"
    },
    "alerts": {
      "exampleButton": "Beispiel einfügen"
    },
    "appsInfo": {
      "shared": {
        "generalFeedback": "Allgemeines Feedback",
        "introduction": "Dieses Tool bietet dir viele Einsatzmöglichkeiten für Schule und Unterricht:",
        "toolSpecificFaqs": "Fragen zum Tool {name}",
        "videoTutorial": "So funktioniert dieses Tool"
      }
    },
    "authorInfoModal": {
      "creativeCommons": "Sie stehen unter der <a href='https://creativecommons.org/licenses/by/4.0/' target='_BLANK'>Creative Commons Lizenz CC-BY 4.0</a>.",
      "header": "Über diese Inhalte",
      "listHeader": "Du darfst:",
      "listHtmlPublic": "<li><i class=\"bi bi-check2\"></i><strong>Teilen</strong> — die Inhalte in jedem Format oder Medium vervielfältigen und weiterverbreiten.</li>\n<li><i class=\"bi bi-check2\"></i><strong>Bearbeiten</strong> — die Inhalte remixen, verändern und darauf aufbauen und zwar für beliebige Zwecke, sogar kommerziell.</li>\n<li><i class=\"bi bi-exclamation-triangle\"></i>Bei einer Weiterverarbeitung verpflichtest du dich, <strong>angemessene Rechteangaben</strong> zu machen und <strong>{name} als Urheber*in zu nennen</strong>. Bei der Weiterverarbeitung innerhalb der fobizz Tools werden diese Bedingungen automatisch erfüllt.</li>",
      "paragraphHtmlIntro": "Diese Inhalte wurden von <strong>{name}</strong> mit den <a href=\"https://app.fobizz.com/\" target=\"_blank\">fobizz Tools</a> erstellt.",
      "paragraphHtmlPrivate": "Die Inhalte dürfen <strong>nur mit ausdrücklicher Zustimmung von {name}</strong> geteilt, vervielfältigt oder weiterverbreitet werden.",
      "paragraphHtmlPrivateHead": "Diese Inhalte wurden nur <strong>für bestimmte Personen</strong> mit Freigabelink freigegeben.",
      "paragraphHtmlPublic": "Diese Inhalte wurden auf Basis der <a href='{link}' target='_BLANK'>Inhalte von <strong>{name}</strong></a> erstellt."
    },
    "buttons": {
      "add": "Hinzufügen",
      "apply": "Verwenden",
      "cancel": "Abbrechen",
      "chooseFile": "Datei auswählen",
      "clearSearch": "Suche zurücksetzen",
      "close": "Schließen",
      "copy": "Kopieren",
      "copySmall": "kopieren",
      "createContent": "Inhalt anlegen",
      "delete": "Löschen",
      "deleteImage": "Bild löschen",
      "edit": "Bearbeiten",
      "enableRecordingDevice": "Aufnahmegerät aktivieren",
      "finished": "Fertig",
      "generatePreviewImage": "Bild generieren",
      "generateSuggestion": "Vorschlag generieren",
      "generateText": "Text erzeugen",
      "go": "Los geht's",
      "insert": "Einfügen",
      "insertElement": "Element einfügen",
      "loadMore": "Mehr laden",
      "move": "Verschieben",
      "next": "Weiter",
      "previous": "Zurück",
      "reRecord": "Aufnahme neu starten",
      "reload": "Neu laden",
      "save": "Speichern",
      "select": "Auswählen",
      "startRecording": "Aufnahme starten",
      "stopRecording": "Aufnahme stoppen",
      "submit": "Abschicken",
      "toggleFilterMenu": "Filtermenü ein-/ausblenden",
      "tryAgain": "Erneut versuchen",
      "understood": "Verstanden",
      "uploadAnotherFile": "Andere Datei hochladen",
      "uploadFile": "Datei hochladen",
      "useToolsUnlimited": "fobizz unlimitiert nutzen",
      "no": "Nein",
      "yes": "Ja"
    },
    "confirmDialog": {
      "discardItem": {
        "confirm": "Verschieben",
        "text": "Der Inhalt ({modelName}) wird aus deiner Übersicht entfernt. Du findest ihn danach im Papierkorb.",
        "title": "Inhalt in den Papierkorb verschieben?"
      },
      "promptCheckCancel": "Anpassen",
      "promptContentFilter": {
        "confirm": "Senden",
        "text": "Unsere Sicherheitsfilter haben deine Eingabe als sensibel eingestuft. Du kannst sie anpassen oder unverändert senden.",
        "title": "Eingabe blockiert"
      },
      "promptPrivacy": {
        "confirm": "Senden",
        "text": "Dein Prompt scheint personenbezogene Daten zu enthalten. Beim Absenden wird er an die KI übertragen.",
        "title": "Persönliche Daten im Prompt?"
      }
    },
    "confirms": {
      "reRecord": {
        "confirm": "Verwerfen & neu starten",
        "text": "Deine aktuelle Aufnahme wird verworfen, damit du eine neue starten kannst.",
        "title": "Aufnahme neu starten?"
      },
      "unsavedChanges": {
        "discard": "Verwerfen",
        "text": "Du hast ungespeicherte Änderungen. Möchtest du sie speichern?",
        "title": "Ungespeicherte Änderungen"
      }
    },
    "courses": {
      "labels": {
        "completed": "Abgeschlossen",
        "course": "Fortbildung",
        "enrolled": "eingeschrieben",
        "impulse": "Impuls",
        "recording": "Aufzeichnung",
        "webinar": "Webinar",
        "workshop": "Workshop",
        "b2bWorkshop": "Schulintern"
      }
    },
    "emptyState": {
      "ai": {
        "noHistoryDescription": "Probiere gerne die KI Tools aus, um neue Inhalte zu anlegen.",
        "noHistoryTitle": "Du hast bisher keine Anfragen gestellt."
      }
    },
    "enums": {
      "autoCleanup": {
        "day": "1 Tag",
        "month": "1 Monat",
        "months_18": "18 Monate",
        "never": "Niemals",
        "week": "1 Woche",
        "year": "1 Jahr"
      },
      "companyKinds": {
        "kind_school": "Schule",
        "kind_community_college": "Volkshochschule",
        "kind_other": "Sonstiges",
        "kind_teacher_training": "Studienseminar/Lehrkräfteausbildung",
        "kind_institute": "Fortbildungsinstitut",
        "kind_media_center": "Medienzentrum",
        "kind_college": "Universität/Hochschule",
        "kind_company": "Firma/Organisationen",
        "kind_government_agency": "Behörde/Verwaltung",
        "kind_national_license": "Landeslizenz",
        "kind_goethe_institute": "Goethe-Institut",
        "kind_supporting_institution": "Träger",
        "kind_tutoring": "Nachhilfe",
        "kind_language_school": "Sprachschule"
      },
      "courseTargetGroupTypes": {
        "TARGET_GROUP_TYPE_TEACHERS": "Lehrkräfte",
        "TARGET_GROUP_TYPE_SCHOOL_BOARDS": "Schulleitungen",
        "TARGET_GROUP_TYPE_SCHOOL_EXECUTIVES": "Lehrkräfte in leitender Position",
        "TARGET_GROUP_TYPE_TEACHER_TRAINEES": "Lehramtsstudent*innen",
        "TARGET_GROUP_TYPE_STUDENT_TEACHERS": "Referendar*innen",
        "TARGET_GROUP_TYPE_SCHOOL_LEADERS": "Schulleiter*innen"
      },
      "gradeLevels": {
        "GRADE_LEVEL_1_2": "1./2. Klasse",
        "GRADE_LEVEL_3_4": "3./4. Klasse",
        "GRADE_LEVEL_HIGH": "Oberstufe",
        "GRADE_LEVEL_LOWER": "Unterstufe",
        "GRADE_LEVEL_MIDDLE": "Mittelstufe"
      },
      "international": {
        "false": "Deutschsprachiges Schulsystem",
        "true": "Englischsprachiges Schulsystem"
      },
      "itemNodes": {
        "AudioRecorder::File": "Audio-Aufnahme",
        "LinkShortener::Link": "Link kürzen",
        "ScreenRecorder::File": "Bildschirm-Aufnahme",
        "Tools::Ai::Assistant": "KI-Assistent",
        "Tools::Ai::Converter": "Inhalt",
        "Tools::Ai::Feedback": "KI-Korrekturhilfe",
        "Tools::Ai::Image": "KI-Bild",
        "Tools::ClassroomScreen::Screen": "Digitale Tafel",
        "Tools::FileSharing::File": "Datei teilen",
        "Tools::Pinboard::Board": "Pinnwand",
        "Tools::Pinboard::Card": "Pinnwand",
        "Tools::Pinboard::Comment": "Pinnwand",
        "Tools::Pinboard::List": "Pinnwand",
        "Tools::PupilFeedback::Assignment": "KI-Feedback",
        "Tools::PupilFeedback::Feedback": "KI-Feedback",
        "Tools::Surveys::Survey": "Umfrage",
        "Tools::Surveys::SurveyResponse": "Umfrage",
        "Tools::TextEditor::Document": "Textdokument",
        "Tools::Website::Page": "Website",
        "Tools::WordClouds::WordCloud": "Wortwolke",
        "Tools::WordClouds::WordEntry": "Wortwolke",
        "Tools::Worksheet::Response": "Abgabe",
        "Tools::Worksheet::Worksheet": "Arbeitsblatt",
        "VideoRecorder::File": "Video-Aufnahme",
        "folder": "Ordner"
      },
      "languages": {
        "de": "Deutsch",
        "en": "Englisch",
        "es": "Spanisch",
        "fr": "Französisch",
        "it": "Italienisch",
        "nl": "Niederländisch",
        "ru": "Russisch",
        "ua": "Ukrainisch"
      },
      "privacyLevel": {
        "locked": "Gesperrt",
        "members_only": "Nur Mitglieder",
        "password_protected": "Mit Passwort geschützt",
        "public_for_all": "Als OER verfügbar",
        "secret": "Sichtbar"
      },
      "profileGradeTypes": {
        "GRADE_TYPE_ELEMENTARY_SCHOOL": "Grundschule",
        "GRADE_TYPE_LOWER_GRADE": "Unterstufe",
        "GRADE_TYPE_MIDDLE_LEVEL": "Mittelstufe",
        "GRADE_TYPE_OTHER": "Sonstiges",
        "GRADE_TYPE_SPECIAL_SCHOOL": "Förderschule",
        "GRADE_TYPE_UPPER_SCHOOL": "Oberstufe",
        "GRADE_TYPE_VOCATIONAL_SCHOOL": "Berufliche Schule"
      },
      "schoolTypes": {
        "SCHOOL_TYPE_ACADEMIC_HIGH_SCHOOL": "Gymnasium",
        "SCHOOL_TYPE_COMPREHENSIVE_SCHOOL": "Gesamtschule",
        "SCHOOL_TYPE_CUSTOM": "Sonstiges",
        "SCHOOL_TYPE_ELEMENTARY_SCHOOL": "Grundschule",
        "SCHOOL_TYPE_MAIN_SCHOOL": "Haupt-/Mittelschule",
        "SCHOOL_TYPE_MIDDLE_SCHOOL": "Realschule",
        "SCHOOL_TYPE_SECONDARY_SCHOOL": "Weiterführende Schule",
        "SCHOOL_TYPE_SPECIAL_SCHOOL": "Förderschule",
        "SCHOOL_TYPE_UNIVERSITY": "Hochschule/Uni",
        "SCHOOL_TYPE_VOCATIONAL_SCHOOL": "Berufliche Schule"
      },
      "subjectTypes": {
        "SUBJECT_TYPE_ART": "Kunst",
        "SUBJECT_TYPE_BIOLOGY": "Biologie",
        "SUBJECT_TYPE_CHEMISTRY": "Chemie",
        "SUBJECT_TYPE_COMPUTER_SCIENCE": "Informatik",
        "SUBJECT_TYPE_ECONOMY": "Wirtschaft",
        "SUBJECT_TYPE_ENGLISH": "Englisch",
        "SUBJECT_TYPE_ESL": "DaZ/DaF",
        "SUBJECT_TYPE_ETHICS": "Ethik",
        "SUBJECT_TYPE_FOREIGN_LANGUAGES": "Fremdsprachendidaktik",
        "SUBJECT_TYPE_GEOGRAPHIE": "Geographie",
        "SUBJECT_TYPE_GERMAN": "Deutsch",
        "SUBJECT_TYPE_HISTORY": "Geschichte",
        "SUBJECT_TYPE_MATH": "Mathematik",
        "SUBJECT_TYPE_MEDIA": "Medien",
        "SUBJECT_TYPE_MUSIC": "Musik",
        "SUBJECT_TYPE_NATURAL_SCIENCES": "Naturwissenschaften",
        "SUBJECT_TYPE_OTHER": "Sonstiges",
        "SUBJECT_TYPE_PERSONAL_EDUCATION": "Sachunterricht",
        "SUBJECT_TYPE_PHILOSOPHIE": "Philosophie",
        "SUBJECT_TYPE_PHYSICS": "Physik",
        "SUBJECT_TYPE_POLITICS": "Gesellschaft/Politik",
        "SUBJECT_TYPE_RELIGION": "Religion",
        "SUBJECT_TYPE_SPORT": "Sport",
        "SUBJECT_TYPE_TECHNOLOGY": "Technik",
        "SUBJECT_TYPE_UNSPECIFIC": "Fächerübergreifend"
      }
    },
    "flash": {
      "addFileSuccess": "Datei {filename} hinzugefügt",
      "errorOccurred": "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
      "premiumLimitWarning": "Nur noch eine Premium-Anfrage für heute übrig | Nur noch {count} Premium-Anfragen für heute übrig",
      "premiumLimitResetsAtMidnight": "Das Limit wird um Mitternacht zurückgesetzt.",
      "premiumLimitFallback": "Premium-Limit für heute erreicht",
      "premiumLimitFallbackDescription": "{model} übernimmt bis Mitternacht.",
      "premiumLimitReached": "Premium-Limit für heute erreicht",
      "premiumLimitReachedDescription": "Ab Mitternacht kannst du wieder Premium-Modelle nutzen.",
      "alreadyLoggedIn": "Du bist bereits eingeloggt",
      "bookmarkSuccess": "Zu Merkliste hinzugefügt",
      "bookmarkSuccessLink": "Zur Merkliste",
      "connectionReestablished": "Verbindung wurde erneut hergestellt",
      "paidLicenseRequired": "Für dieses Tool benötigst du eine kostenpflichtige Lizenz",
      "remixStarted": "\"{name}\" wird geremixed",
      "remixSuccess": "\"{name}\" wurde erstellt",
      "removeFileSuccess": "Datei {filename} entfernt",
      "successfullyCreated": "Erfolgreich erstellt",
      "successfullyDeleted": "Erfolgreich gelöscht",
      "successfullyUpdated": "Erfolgreich aktualisiert",
      "templateMarkSuccess": "{name} als Template markiert",
      "tooManyRequests": "Zu viele Anfragen. Bitte versuche es in ein paar Sekunden erneut.",
      "templateUnmarkSuccess": "{name} als Template entfernt",
      "unbookmarkSuccess": "Aus Merkliste entfernt",
      "undiscardItemSuccess": "\"{name}\" wurde wiederhergestellt"
    },
    "footer": {
      "aboutUs": "Über fobizz",
      "aiAndTools": "KI und Tools",
      "aiAndToolsHelp": "Hilfe zu Tools & KI-Anwendungen",
      "aiGuidelines": "Umgang mit KI (EU AI Act)",
      "alternativeText": "Datenschutz Siegel, das einen hohen und geprüften Datenschutz auszeichnet",
      "certificatesHelp": "Hilfe zu Zertifikaten",
      "company": "Unternehmen",
      "courses": "Fortbildungen",
      "coursesHelp": "Hilfe zu Fortbildungen und Webinaren",
      "enrollmentHelp": "Hilfe zu Einschreibungen",
      "freeTrial": "Kostenfreier Probezugang",
      "appStoreAriaLabel": "Im App Store laden",
      "getTheApp": "Jetzt die App laden:",
      "googlePlayAriaLabel": "Bei Google Play herunterladen",
      "gettingStarted": "Tipps zum Start mit fobizz",
      "helpAndContact": "Hilfe und Kontakt",
      "imprint": "Impressum",
      "jobs": "Jobs",
      "language": "Sprache",
      "legal": "Rechtliches",
      "licenses": "Lizenzen",
      "newsletter": "Newsletter abonnieren",
      "partners": "Unsere Partner",
      "partnersHelp": "Hilfe zu den Partnern",
      "privacyPolicy": "Datenschutz",
      "schoolLicensePrices": "Preise für Schul- und Gruppenlizenzen",
      "shareWithColleagues": "Inhalte mit Kolleg*innen teilen",
      "shareWithStudents": "Inhalte mit Schüler*innen teilen",
      "singleLicensePrices": "Preise für Einzellizenzen",
      "tAndC": "AGB",
      "teachingMaterial": "Unterrichtsmaterial",
      "teachingMaterialHelp": "Hilfe zu Unterrichtsmaterialien",
      "team": "Team",
      "technicalHelp": "Erste Hilfe bei Problemen",
      "toTeach": "fobizz und to teach",
      "urls": {
        "aboutUs": "https://fobizz.com/de/was-ist-fobizz/",
        "aiAndTools": "https://app.fobizz.com",
        "aiAndToolsHelp": "https://app.fobizz.com/de/help/categories/54-fobizz-tools",
        "aiGuidelines": "https://app.fobizz.com/de/help/categories/60-k-guidelines",
        "certificatesHelp": "https://app.fobizz.com/de/help/articles/78-weiterbildung-zertifikat-erhalten",
        "courses": "https://app.fobizz.com/fortbildungen",
        "coursesHelp": "https://app.fobizz.com/de/help/categories/50-fortbildungen",
        "enrollmentHelp": "https://app.fobizz.com/de/help/articles/311-kurs-einschreiben",
        "freeTrial": "https://app.fobizz.com/de/help/articles/310-fobizz-kostenfrei-testen",
        "gettingStarted": "https://app.fobizz.com/de/help/articles/133-start-empfehlungen",
        "helpAndContact": "https://app.fobizz.com/de/help",
        "imprint": "https://app.fobizz.com/imprints",
        "jobs": "https://fobizz.com/de/unsere-jobs/",
        "licenses": "https://app.fobizz.com/de/help/articles/273-kosten-fobizz",
        "newsletter": "https://fobizz.com/de/neuigkeiten-per-newsletter",
        "partners": "https://app.fobizz.com/partners",
        "partnersHelp": "https://app.fobizz.com/de/help/categories/56-unsere-partner",
        "privacyPolicy": "https://app.fobizz.com/data_protections",
        "schoolLicensePrices": "https://app.fobizz.com/de/help/articles/102-schullizenz-preise-und-paketgroessen",
        "shareWithColleagues": "https://app.fobizz.com/de/help/articles/26-wie-kann-ich-materialien-mit-meinen-kolleg-innen-teilen",
        "shareWithStudents": "https://app.fobizz.com/de/help/articles/20-inhalte-mit-schueler-innen-teilen",
        "singleLicensePrices": "https://app.fobizz.com/de/help/articles/279-abo-einzelizenz",
        "teachingMaterial": "https://app.fobizz.com/gallery",
        "teachingMaterialHelp": "https://app.fobizz.com/de/help/categories/59-unterrichtsmaterialien",
        "team": "https://fobizz.com/de/team/",
        "technicalHelp": "https://app.fobizz.com/de/help/categories/62-technische-probleme",
        "termsAndConditions": "https://app.fobizz.com/terms_and_conditions",
        "toTeach": "https://fobizz.com/de/to-teach/",
        "useToolsWithStudents": "https://app.fobizz.com/de/help/articles/309-tools-schueler-innen-nutzen"
      },
      "useToolsWithStudents": "Tools mit Schüler*innen nutzen"
    },
    "global": {
      "all": "Alle",
      "emptyFilterHeading": "Wir konnten leider keine passenden Inhalte finden.",
      "emptyFilterText": "Probiere es gern mit einem anderen Begriff oder versuche den Filter anzupassen.",
      "filterContent": "Inhalte filtern",
      "resetFilter": "Filter zurücksetzen"
    },
    "headers": {
      "aiImageSearch": "Meine KI Bilder",
      "auto_cleanup": "Automatische Löschung",
      "background": "Hintergrund",
      "backgroundColor": "Hintergrundfarbe",
      "backgroundPreview": "Hintergrundvorschau",
      "camera": "Kamera",
      "colorAndPattern": "Farbe und Muster",
      "colors": "Farben",
      "editFolder": "Ordner bearbeiten",
      "files": "Dateien",
      "hint": "Hinweis",
      "image": "Bild",
      "imageSearch": "Bildersuche",
      "imageUploadHint": "Du kannst es jetzt auf dem Arbeitsblatt sehen",
      "imageUploadSuccess": "Bild erfolgreich hochgeladen.",
      "images": "Bilder",
      "previewImage": "Vorschaubild",
      "latex": "LaTeX",
      "link": "Link",
      "microphone": "Mikrofon",
      "patterns": "Muster",
      "recording": "Aufnahme",
      "settings": "Einstellungen",
      "share": "Teilen",
      "statistics": "Statistik",
      "toolSpecificFaqs": "Fragen zum Tool {name}",
      "videoTutorial": "So funktioniert dieses Tool",
      "views": "Aufrufe",
      "visitorPermissions": "Besucher*innen-Berechtigung"
    },
    "feedback": {
      "thumbsDown": "Nicht hilfreich",
      "thumbsUp": "Gefällt mir"
    },
    "help": {
      "autoCleanup": {
        "day": "Daten werden nach einem Tag gelöscht.",
        "month": "Daten werden nach einem Monat gelöscht.",
        "never": "Daten werden nicht automatisch gelöscht.",
        "week": "Daten werden nach einer Woche gelöscht."
      },
      "embed": "Kopiere das Code Snippet, um es über iframe in andere Webseiten einzubetten.",
      "jsRequired": "JavaScript wird benötigt",
      "maxCharacters": "Maximal {max} Zeichen",
      "privacyLevel": {
        "locked": "Verberge die Inhalte nachträglich oder temporär. Nur du kannst sie sehen und bearbeiten.",
        "members_only": "Nicht öffentlich. Nur eingeloggte Mitglieder haben Zugriff.",
        "password_protected": "Schütze die Inhalte zusätzlich per Passwort.",
        "public_for_all": "Veröffentliche die Inhalte als OER in der fobizz Galerie für Unterrichtsmaterial. <a href=\"/gallery/how_to\" target=\"_blank\">Mehr erfahren</a>",
        "secret": "Nur Personen, denen du den Link schickst, können die Inhalte weiterverwenden."
      },
      "visitorPermissions": {
        "visitor_permissions_invisible": "Besucher*innen können Inhalte nicht sehen.",
        "visitor_permissions_read": "Besucher*innen können Inhalte sehen.",
        "visitor_permissions_write": "Besucher*innen können Inhalte bearbeiten."
      }
    },
    "hints": {
      "allowedFileTypes": "Erlaubte Dateitypen",
      "converting": "Datei wird umgewandelt...",
      "copied": "In Zwischenablage kopiert",
      "creating": {
        "docx": "Word-Dokument wird erstellt...",
        "pdf": "PDF wird erstellt...",
        "pptx": "PowerPoint-Präsentation wird erstellt..."
      },
      "dataProtectionFileUpload": "Lade keine sensiblen oder persönliche Informationen hoch und wahre die Urheberrechte bei der Nutzung von fremden Inhalten.",
      "dataProtectionFileUploadTitle": "Schütze deine Daten beim Upload von Dateien",
      "dragDrop": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen",
      "dragOrSelectFile": "Bild hier reinziehen oder",
      "dragOrSelectImage": "Bild hier hineinziehen oder auswählen",
      "imageUploading": "Bild wird hochgeladen...",
      "drop": "Datei hier fallen lassen",
      "dropFile": "Datei hier reinziehen oder",
      "embedIFrame": "Mit einem Klick auf dieses Vorschaubild stimmst du zu, dass die angezeigten Inhalte nachgeladen und hierzu die erforderlichen Daten und insbesondere deine IP-Adresse an den Anbieter der Inhalte übermittelt werden. Weitere Informationen findest du in unserer Datenschutzerklärung.",
      "embedIFramePupil": "Mit einem Klick auf dieses Vorschaubild werden angezeigte Inhalte nachgeladen und hierzu die erforderlichen Daten und insbesondere deine IP-Adresse an den Anbieter der Inhalte übermittelt werden. Im Zweifel frage deine Lehrkraft.",
      "exampleAlert": "Wie kann das aussehen?",
      "exampleButton": "Beispiel einfügen",
      "fileLimit": "(maximal {size} MB)",
      "inputLabel": "Dein Prompt",
      "latexSyntax": "Du kannst <a href=\"https://katex.org/docs/supported\" target=\"_blank\">LaTeX Syntax</a> verwenden",
      "legacyBrowserBanner": "Es scheint, dass du einen veralteten Browser verwendest. Bitte aktualisiere deinen Browser, um unsere Webseite in vollem Umfang nutzen zu können. Mit einem aktuellen Browser verbesserst du nicht nur deine Sicherheit, sondern auch die Darstellung und Funktionalität unserer Seite.",
      "loading": "Lädt...",
      "maxFileSize": "Maximal {size} MB",
      "maxRecordingLength": "Aufnahmen können bis zu 4 Minuten lang sein.",
      "noItems": "Du hast hier noch nichts angelegt. Jetzt loslegen!",
      "noOptions": "Die Liste ist leer",
      "noResults": "Keine Ergebnisse gefunden",
      "notSpecified": "Noch keine Angabe",
      "ready": {
        "docx": "Word-Dokument bereitgestellt",
        "pdf": "PDF bereitgestellt",
        "pptx": "PowerPoint-Präsentation bereitgestellt"
      },
      "previewImageDragDrop": "Bild hierher ziehen oder klicken zum Hochladen",
      "progressMessage": "Bearbeitung läuft...",
      "progressMessageQueued": "In Warteschlange...",
      "prompt": "Wichtig: Teile niemals persönliche Daten mit der KI und prüfe die Antworten kritisch.",
      "selectFile": "Datei auswählen",
      "serverStatus": "Gerade ist viel los und unsere Tools sind stark ausgelastet. Es kann sein, dass deine Anfrage länger dauert als gewöhnlich. Danke für deine Geduld. Wir arbeiten bereits daran, dass das System wieder in normaler Geschwindigkeit funktioniert.",
      "settingsSaved": "Deine Einstellungen wurden gespeichert.",
      "submittingDescription": "Falls es einmal länger dauern sollte: Der Prozess läuft im Hintergrund weiter. Du kannst zwischendurch etwas anderes tun und findest das Ergebnis in der Historie rechts oben.",
      "uploading": "Datei wird hochgeladen...",
      "uploadingProgress": "Datei wird hochgeladen: {progress}",
      "visitorMaterial": "Du nutzt fobizz als Gast - alle Inhalte werden nach 2 Tagen gelöscht. <strong><a href=\"{url}\" target=\"_blank\">Melde dich an</a></strong>, um deine Inhalte zu speichern."
    },
    "infoModal": {
      "classroom_screen": "<h3><strong>Unterrichtsentwurf</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Thema</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Name / Thema der Unterrichtseinheit</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Empfohlene Zeit</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>z.B. 45/90 Minuten</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Lernziel</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Worin liegt das vorrangige Ziel der Unterrichtsstunde? Welcher Kompetenzerwerb/-zuwachs soll am Ende der Stunde erreicht werden?</em></p></td></tr></tbody></table><p></p><h3><strong>Verlaufsplanung</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Dauer (Min)</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Phase</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Unterrichtsgeschehen / Lehrer*innen-Schüler*innen-Interaktion</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Sozialform / Arbeitsform</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Medien / Materialien</strong></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>5</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Einstieg</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>10</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Erarbeitung</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td></tr></tbody></table><p></p><p><strong>Weitere Informationen</strong></p><p><em>Beschreibung der Inhalte und Ablauf der Unterrichtseinheit. Hinweise zur Unterrichtsdurchführung und - vorbereitung. Ggf. Erläuterungen zu Lehrplanbezug und didaktisch-methodische Entscheidungen.</em></p><p></p>",
      "title": "Zusatzinfos für Lehrkräfte"
    },
    "labels": {
      "aiEnabled": "KI aktiviert",
      "authorName": "Autor*in",
      "confirm": "Bestätigen",
      "continue": "Weiter",
      "customSubjectType": "Sonstiges Schulfach",
      "description": "Beschreibung",
      "notSpecified": "Nicht angegeben",
      "gradeLevels": "Klassenstufen",
      "imageSearch": {
        "categories": "Tiere, Dinosaurier, Natur, Landschaft, Strand, Meer, Himmel, Weltraum, Auto, Objekte, Mode, Büro, Kinder, Menschen, Familie, Geschichten",
        "noMoreResults": "Keine weiteren Bilder gefunden"
      },
      "international": "Inhalte für",
      "itemTotals": "{firstItem} - {lastItem} von {totalCount} Einträgen",
      "language": "Sprache",
      "latex": "LaTeX Eingabe",
      "loading": "Lädt...",
      "name": "Name",
      "new": "Neu",
      "nextPage": "Nächste Seite",
      "page": "Seite",
      "previousPage": "Vorherige Seite",
      "password": "Passwort",
      "preview": "Vorschau",
      "pseudonym": "Trage hier dein Pseudonym oder Namenskürzel ein.",
      "schoolTypes": "Schulformen",
      "search": "Suche",
      "subjectTypes": "Schulfächer",
      "title": "Titel",
      "withAi": "Mit KI"
    },
    "languages": {
      "de": "Deutsch",
      "en": "Englisch",
      "es": "Spanisch",
      "fr": "Französisch"
    },
    "limitUpsellBox": {
      "bodySubtitleHtml": "Empfehle deinem Kollegium die <strong>fobizz Schullizenz</strong> oder hol die <strong>Einzellizenz</strong> nur für dich.",
      "bodyTitle": "Möchtest du fobizz unbegrenzt nutzen?",
      "header": {
        "ai_assistant": {
          "multiple": "<strong>{more} {number} Assistenten</strong> anlegen",
          "one": "<strong>noch einen Assistenten</strong> anlegen"
        },
        "ai_chat": {
          "multiple": "dir von der KI Chat <strong>{more} {number} Antworten</strong> geben lassen",
          "one": "dir von der KI Chat <strong>noch eine Antwort</strong> geben lassen"
        },
        "ai_chat_completion": {
          "multiple": "<strong>{more} {number} Antworten</strong> vom KI Chat erhalten",
          "one": "<strong> eine Antwort</strong> vom KI Chat erhalten"
        },
        "ai_converter": {
          "multiple": "<strong>{more} {number} Anfragen</strong> an das KI-Multimedia Tool stellen",
          "one": "<strong>noch eine Anfrage</strong> an das KI-Multimedia Tool stellen"
        },
        "ai_document_qa": {
          "multiple": "<strong>{more} {number} Dokumente</strong> für die KI für Dokumente hochladen",
          "one": "<strong>noch ein Dokument</strong> für die KI für Dokumente hochladen"
        },
        "ai_feedback": {
          "multiple": "<strong>{more} {number} Anfragen</strong> an die KI Korrekturhilfe stellen",
          "one": "<strong>noch eine Anfrage</strong> an die KI Korrekturhilfe stellen"
        },
        "ai_image": {
          "multiple": "<strong>{more} {number} Bilder</strong> anlegen",
          "one": "<strong>ein Bild</strong> anlegen"
        },
        "ai_mini_tool": {
          "multiple": "<strong>{more} {number} Anfragen</strong> an das Promptlabor stellen",
          "one": "<strong>noch eine Anfrage</strong> an das Promptlabor stellen"
        },
        "ai_persona": {
          "multiple": "<strong>{more} {number} Anfragen</strong> an die KI für Personen stellen",
          "one": "<strong>noch eine Anfrage</strong> an die KI für Personen stellen"
        },
        "audio_recorder": {
          "multiple": "<strong>{more} {number} Audio-Aufnahmen</strong> machen",
          "one": "<strong>noch eine Audio-Aufnahme</strong> machen"
        },
        "classroom_screen": {
          "multiple": "<strong>{more} {number} Tafeln</strong> anlegen",
          "one": "<strong>noch eine Tafel</strong> anlegen"
        },
        "file_sharing": {
          "multiple": "<strong>{more} {number} Dateien</strong> teilen",
          "one": "<strong>noch eine weitere Datei</strong> teilen"
        },
        "licenseRequiredHtml": "<h2>Um dieses Tool zu nutzen, brauchst du eine fobizz Lizenz.</h2><p>Informiere dich über unsere Lizenzen für eine unlimitierte Nutzung.</p>",
        "limitReachedHtml": "<h2>Du hast dein monatliches Limit für dieses Tool erreicht.</h2><p>Informiere dich über unsere Lizenzen für eine unlimitierte Nutzung.</p>",
        "limitReachedVisitor": "Du hast dein Tageslimit an Antworten von der KI-Assistenz aufgebraucht.",
        "link_shortener": {
          "multiple": "<strong>{more} {number} Links</strong> kürzen",
          "one": "<strong>noch einen Link</strong> kürzen"
        },
        "monthlyLimitNotReached": "Du kannst diesen Monat noch {actionText}.",
        "monthlyLimitNotReachedVisitor": "Als Gast kannst du diesen Monat noch {actionText}",
        "more": "weitere",
        "pinboard": {
          "multiple": "<strong>{more} {number} Pinnwände</strong> anlegen",
          "one": "<strong>noch eine Pinnwand</strong> anlegen"
        },
        "pupil_feedback": {
          "multiple": "<strong>{more} {number} Aufgaben</strong> mit der KI für Feedback anlegen",
          "one": "<strong>noch eine Aufgabe</strong> mit der KI für Feedback anlegen"
        },
        "qrcodes": {
          "multiple": "<strong>{more} {number} QR-Codes</strong> anlegen",
          "one": "<strong>noch einen QR-Code</strong> anlegen"
        },
        "registerNow": "<strong><a href=\"{url}\" target=\"_blank\">Registriere dich kostenlos</a></strong>, um weiter mit den Tools zu arbeiten.",
        "school_classes": {
          "multiple": "<strong>{more} {number} Klassenräume</strong> anlegen",
          "one": "<strong>noch einen Klassenraum</strong> anlegen"
        },
        "screen_recorder": {
          "multiple": "<strong>{more} {number} Bildschirm-Aufnahmen</strong> machen",
          "one": "<strong>noch eine Bildschirm-Aufnahme</strong> machen"
        },
        "shared_space_link": {
          "multiple": "<strong>{more} {number} Klassenräume</strong> anlegen",
          "one": "<strong>noch einen Klassenraum</strong> anlegen"
        },
        "surveys": {
          "multiple": "<strong>{more} {number} Umfragen</strong> anlegen",
          "one": "<strong>noch eine Umfrage</strong> anlegen"
        },
        "text_editor": {
          "multiple": "<strong>{more} {number} Textdokumente</strong> anlegen",
          "one": "<strong>noch ein Textdokument</strong> anlegen"
        },
        "video_recorder": {
          "multiple": "<strong>{more} {number} Video-Aufnahmen</strong> machen",
          "one": "<strong>noch eine Video-Aufnahme</strong> machen"
        },
        "website": {
          "multiple": "<strong>{more} {number} Websites</strong> anlegen",
          "one": "<strong>noch eine Website</strong> anlegen"
        },
        "word_clouds": {
          "multiple": "<strong>{more} {number} Wortwolken</strong> anlegen",
          "one": "<strong>noch eine Wortwolke</strong> anlegen"
        },
        "worksheet": {
          "multiple": "<strong>{more} {number} Arbeitsblätter</strong> anlegen",
          "one": "<strong>noch ein Arbeitsblatt</strong> anlegen"
        }
      },
      "activation": {
        "question": "Deine Einrichtung hat bereits eine Lizenz?",
        "success": "Lizenz erfolgreich aktiviert! Du bist jetzt Mitglied von \"{groupTitle}\"."
      },
      "upsellCard": {
        "group": {
          "description": "Die Gruppenlizenz lohnt sich bereits ab 5 Personen.",
          "linkText": "Infos zur Gruppenlizenz",
          "linkUrl": "https://fobizz.com/de/angebote-fuer-schulen-und-gruppen/",
          "title": "Gemeinsam mit Kolleg*innen"
        },
        "individual": {
          "description": "Alle Angebote für dich als einzelne Lehrkraft entdecken.",
          "linkText": "Infos zur Einzellizenz",
          "linkUrl": "https://app.fobizz.com/pricing",
          "title": "Individuell für dich"
        }
      }
    },
    "links": {
      "accept": "Ich habe die Hinweise zur Kenntnis genommen",
      "aiAssistants": "KI Assistenten",
      "aiImageSearch": "Meine KI Bilder",
      "back": "Zurück",
      "back_to_curriculum": "Zurück zur Übersicht",
      "clickToEdit": "Klicken zum Bearbeiten",
      "close": "Schließen",
      "copied": "Kopiert!",
      "copy": "Kopieren",
      "create": "Anlegen",
      "createNew": "Neu anlegen",
      "createTool": "{name} anlegen",
      "createWithTemplate": "Vorlage auswählen",
      "createWithoutTemplate": "Anlegen",
      "dataProtection": "Datenschutz",
      "delete": "Löschen",
      "discard": "In Papierkorb verschieben",
      "download": "Herunterladen",
      "downloadCSV": "Als CSV herunterladen",
      "duplicate": "Duplizieren",
      "edit": "Bearbeiten",
      "exportAs": {
        "docx": "Word exportieren",
        "pdf": "PDF exportieren",
        "pptx": "PowerPoint exportieren"
      },
      "freeRegistration": "Jetzt registrieren",
      "gallery": "Galerie",
      "generateWithAi": "Mit KI generieren",
      "history": "Historie",
      "imageSearch": "Bildersuche",
      "imageSearchPexels": "Bildersuche von Pexels",
      "imageSearchPixabay": "Bildersuche von Pixabay",
      "imprint": "Impressum",
      "learnMore": "Mehr erfahren",
      "legal": "Rechtliches",
      "licenseInfo": "Lizenzinfos",
      "logout": "Ausloggen",
      "moreSettings": "Weitere Einstellungen",
      "move": "Verschieben",
      "moveToFolder": "In Ordner verschieben",
      "new": "Anlegen",
      "open": "Öffnen",
      "openAttachment": "Anhang öffnen",
      "openRow": "Öffne {name}",
      "overview": "Übersicht",
      "preview": "Vorschau",
      "print": "Drucken",
      "remix": "Remix",
      "remove": "Entfernen",
      "reportContent": "Inhalte melden",
      "saveImage": "Bild speichern",
      "savePdf": "PDF speichern",
      "search": "Suche",
      "settings": "Einstellungen",
      "share": "Teilen",
      "showAll": "Alle anzeigen",
      "showMore": "Mehr anzeigen",
      "showQrCode": "QR-Code anzeigen",
      "signup": "Registrieren",
      "templateToggle": "Als Vorlage verwenden",
      "termsAndConditions": "AGBs",
      "themeEditor": "Hintergrund anpassen",
      "toolInfos": "Tutorial und Hilfe",
      "tryNow": "Jetzt ausprobieren",
      "undiscard": "Wiederherstellen",
      "uploadFile": "Datei hochladen",
      "uploadImage": "Bild hochladen"
    },
    "palette": {
      "noColor": "Keine Farbe",
      "noPattern": "Kein Muster"
    },
    "placeholders": {
      "anonymous": "Anonym",
      "answer": "Antwort hier eingeben...",
      "description": "Beschreibung hier eingeben...",
      "password": "Passwort eingeben...",
      "question": "Frage hier eingeben...",
      "selectOption": "Bitte auswählen"
    },
    "preview": {
      "editLink": "Material bearbeiten",
      "hint": "Du befindest dich in der Vorschau.",
      "title": "Vorschau"
    },
    "profileStatus": {
      "licenses": {
        "courses": {
          "basic": {
            "label": "Fortbildungen Basic",
            "tooltip": "Du kannst die kostenfreien Fortbildungen nutzen. Wenn du auf alles zugreifen willst, empfehlen wir dir die Fortbildungs-Flatrate oder die Fortbildungs-Schullizenz."
          },
          "group": {
            "label": "Fortbildungs-Schullizenz",
            "tooltip": "Du hast die Fortbildungs-Schullizenz. Damit kannst du alle Weiterbildungen nutzen."
          },
          "pro": {
            "label": "Fortbildungen-Flatrate",
            "tooltip": "Du hast die Fortbildungs-Flatrate. Damit kannst du alle Weiterbildungen nutzen."
          }
        },
        "tools": {
          "basic": {
            "label": "Tools Basic",
            "tooltip": "Du kannst die Tools nutzen, allerdings mit einem Limit pro Tool. Wenn du alle Tools unbegrenzt nutzen willst, empfehlen wir dir die Tools-Flatrate oder die Tools-Schullizenz."
          },
          "group": {
            "label": "Tools-Schullizenz",
            "tooltip": "Du hast die Tools-Schullizenz. Damit kannst du die Tools ohne Limit nutzen."
          },
          "pro": {
            "label": "Tools-Flatrate",
            "tooltip": "Du hast die Tools-Flatrate. Damit kannst du die Tools ohne Limit nutzen."
          }
        }
      }
    },
    "qrcodeModal": {
      "title": "QR-Code"
    },
    "remixModal": {
      "alert": "Bei diesem Assistenten ist das Hintergrundwissen nicht zum Remix freigegeben. Du kannst einfach deinen eigenen Kontext ergänzen.",
      "button": "Inhalte jetzt remixen",
      "licenseHint": "Hinweis: Dieser Inhalt steht unter der Creative Commons Lizenz CC-BY, d.h. du musst den oder die Autor*in bei der Weiterverwendung nennen.",
      "loginPrompt": "Logge dich in dein fobizz Konto ein, um diese Inhalte zu remixen und für deinen eigenen Unterricht zu verwenden.",
      "paragraph": "Mit der Remix Option erstellst du eine eigene Kopie dieser Inhalte und kannst sie bearbeiten und anpassen.",
      "hint": "⏳ Hinweis: Bei großen Inhalten kann der Remix etwas dauern - der Prozess läuft im Hintergrund weiter. Du findest den Inhalt später in deiner Ablage.",
      "toLogin": "Zur fobizz Anmeldung"
    },
    "response": {
      "labels": {
        "submission": "Abgabe | Abgaben"
      }
    },
    "settingsModal": {
      "labels": {
        "autoCleanup": "{modelName} wird nach diesem Zeitraum gelöscht:"
      }
    },
    "shareOptions": {
      "buttons": {
        "create24hProject": "Klassenraum • 24 h",
        "createSchoolClass": "Klassenraum • 1 Jahr",
        "selectProject": "Klassenraum und Projekt auswählen",
        "shareInSchoolClass": "In Klassenraum teilen",
        "showQRCode": "QR-Code anzeigen"
      },
      "defaultNames": {
        "project24h": "Dein 24h Projekt"
      },
      "hints": {
        "alreadyShared": "Du hast diesen Inhalt bereits in diesem Projekt geteilt. Bitte wähle ein anderes Projekt aus.",
        "error": "Es ist ein Fehler beim Aktualisieren des Klassenraums aufgetreten. Bitte versuche es erneut.",
        "errorShareSettings": "Es ist ein Fehler beim Speichern der Freigabeeinstellungen aufgetreten. Bitte versuche es erneut.",
        "locked": "Inhalt gesperrt. Nur du kannst ihn sehen und bearbeiten.",
        "noSchoolClass": "Du hast noch keinen Klassenraum angelegt. Lege einen an, um Inhalte zu teilen.",
        "password_protected": "Freigabelink ist mit Passwort geschützt.",
        "public_for_all": "Inhalt ist als OER freigegeben und in der fobizz Galerie veröffentlicht.",
        "schoolClassWithoutProject": "Du hast für diesen Klassenraum noch kein Projekt angelegt. Lege ein Projekt an, um Inhalte zu teilen.",
        "secret": "Imhalt ist per Freigabelink zugänglich.",
        "sharedInClassroom": "Im Klassenraum geteilt.",
        "invitedBy": "Einladung von {name}",
        "discardedByOwner": "Gelöscht durch {name}",
        "success": "Dein Klassenraum wurde aktualisiert.",
        "successRemove": "Inhalt wurde aus deinem Klassenraum entfernt."
      },
      "labels": {
        "categories": "Kategorien",
        "iFrame": "Per iFrame",
        "project": "Projekt",
        "schoolClass": "Im Klassenraum",
        "shareInSchoolClass": "Inhalte in Klassenraum teilen",
        "shareLink": "Per Freigabelink",
        "shareSpace": "Klassenraum",
        "sharingSettings": "Freigabeeinstellungen"
      },
      "options": {
        "select": "Auswählen"
      }
    },
    "spinnerDialog": {
      "text": "Vorgang dauert noch ein bisschen"
    },
    "stockImageTypes": {
      "illustration": "Illustration",
      "photo": "Foto",
      "vector": "Vektor"
    },
    "templatesModal": {
      "emptyHint": "Du hast noch keine eigenen Vorlagen gespeichert.",
      "header": "Vorlagen",
      "paragraph": "Starte mit einer eigenen oder von fobizz erstellten Vorlage.",
      "tabFobizzTemplates": "fobizz Vorlagen",
      "tabYourTemplates": "Eigene Vorlagen"
    },
    "time": {
      "oClock": "Uhr",
      "today": "Heute",
      "tomorrow": "Morgen"
    },
    "pseudonymModal": {
      "titles": {
        "pupil_feedback": "KI Feedback"
      }
    },
    "visitorPermissions": {
      "visitor_permissions_invisible": "Versteckt",
      "visitor_permissions_read": "Lesen",
      "visitor_permissions_write": "Schreiben"
    }
  }
}
